import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { refetchTeamMembersInvitationQuotaQuery } from 'features/Team/hooks/useTeamMembersInvitationQuota';

import { refetchTeamMembersQuery } from '../../../../hooks/useTeamMembers';
import { UnlockUserDocument } from './unlockUser.gql';

export const useUnlockUser = (companyUserId: string) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error("'companyProfileId' is undefined in 'useUnlockUser'");
  }

  return useMutation(UnlockUserDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      refetchTeamMembersQuery(companyProfileId),
      refetchTeamMembersInvitationQuotaQuery(companyProfileId),
    ],
    variables: { input: { companyProfileId, companyUserId } },
  });
};
